<template>
    <div>
        <div class="content-header text-center">
            <h2>Market Research</h2>
        </div>
        <p class="text-center">Dataset size affects map load time. The initial dataset is the US Households baseline with 10,000 records, please allow 10-15 seconds for the map to load or update, while using this default dataset. As long as no dataset is specified, the US Households baseline will be used.</p>

                    <form class="form-control p-2" id="mapsearch"  @submit.prevent="updateMapData">
                        <div class="container-fluid">
                            <div class="row align-items-center mb-2">
                                <div class="col">
                                    <div class="p-2">
                                        <div class="col mb-2">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio" v-model="regiontype" value="state">
                                                <label class="form-check-label">
                                                    State
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col mb-2">
                                            <div class="form-check mr-4">
                                                <input class="form-check-input" type="radio" v-model="regiontype" value="zipcode">
                                                <label class="form-check-label">
                                                    Zipcode
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="regiontype === 'zipcode'">
                                        <div class="form-group">
                                            <label>Enter Location (Zipcode)</label>
                                            <input v-model="locationselect" class="form-control input-lg" />
                                        </div>
                                    </div>
                                    <div v-if="regiontype === 'state'">
                                        <div class="form-group">
                                            <label>Select State</label>
                                            <select v-model="locationselect" class="form-select">
                                                <option value="">Make a selection</option>
                                                <option value="AK">AK</option>
                                                <option value="AL">AL</option>
                                                <option value="AR">AR</option>
                                                <option value="AS">AS</option>
                                                <option value="AZ">AZ</option>
                                                <option value="CA">CA</option>
                                                <option value="CO">CO</option>
                                                <option value="CT">CT</option>
                                                <option value="DC">DC</option>
                                                <option value="DE">DE</option>
                                                <option value="FL">FL</option>
                                                <option value="GA">GA</option>
                                                <option value="GU">GU</option>
                                                <option value="HI">HI</option>
                                                <option value="IA">IA</option>
                                                <option value="ID">ID</option>
                                                <option value="IL">IL</option>
                                                <option value="IN">IN</option>
                                                <option value="KS">KS</option>
                                                <option value="KY">KY</option>
                                                <option value="LA">LA</option>
                                                <option value="MA">MA</option>
                                                <option value="MD">MD</option>
                                                <option value="ME">ME</option>
                                                <option value="MI">MI</option>
                                                <option value="MN">MN</option>
                                                <option value="MO">MO</option>
                                                <option value="MP">MP</option>
                                                <option value="MS">MS</option>
                                                <option value="MT">MT</option>
                                                <option value="NC">NC</option>
                                                <option value="ND">ND</option>
                                                <option value="NE">NE</option>
                                                <option value="NH">NH</option>
                                                <option value="NJ">NJ</option>
                                                <option value="NM">NM</option>
                                                <option value="NV">NV</option>
                                                <option value="NY">NY</option>
                                                <option value="OH">OH</option>
                                                <option value="OK">OK</option>
                                                <option value="OR">OR</option>
                                                <option value="PA">PA</option>
                                                <option value="PR">PR</option>
                                                <option value="RI">RI</option>
                                                <option value="SC">SC</option>
                                                <option value="SD">SD</option>
                                                <option value="TN">TN</option>
                                                <option value="TX">TX</option>
                                                <option value="UM">UM</option>
                                                <option value="UT">UT</option>
                                                <option value="VA">VA</option>
                                                <option value="VI">VI</option>
                                                <option value="VT">VT</option>
                                                <option value="WA">WA</option>
                                                <option value="WI">WI</option>
                                                <option value="WV">WV</option>
                                                <option value="WY">WY</option>
                                            </select>
                                        </div>

                                    </div>

                                </div>
                                <div class="col">
                                    <div class="p-2">
                                        <div class="col mb-2">

                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio" v-model="fhacheck" value="all">
                                                <label class="form-check-label">
                                                    FHA Compliance Mode Disable
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col mb-2">
                                            <div class="form-check mr-4">
                                                <input class="form-check-input" type="radio" v-model="fhacheck" value="fha">
                                                <label class="form-check-label">
                                                    FHA Compliance Mode Enable
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="small mb-1">Select Dataset</label>
                                        <select class="form-select" v-model="selecteddb">
                                            <option v-for="option in datasets" :value="option" :key="option">{{option}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col mb-2">
                                    <div class="form-check mr-2">
                                        <input class="form-check-input" type="radio" v-model="maptype" value="markers" @change="selectMapType('markers')">
                                        <label class="form-check-label">
                                            Marker Clusters
                                        </label>
                                    </div>
                                </div>
                                <div class="col mb-2">
                                    <div class="form-check mr-4">
                                        <input class="form-check-input" type="radio" v-model="maptype" value="heatmap" @change="selectMapType('heatmap')">
                                        <label class="form-check-label">
                                            Heatmap
                                        </label>
                                    </div>
                                </div>
                                <div class="col mb-2">
                                    <button class="btn btn-outline-primary float-end" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilters" aria-expanded="true" aria-controls="collapseFilters">
                                        Show/Hide Variables
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="collapse show" id="collapseFilters">
                            <div class="container">
                            <div class="row align-items-center mb-2">
                                <div class="col text-center"><h3>Demographic Variables</h3></div>
                            </div>
                            <div class="row align-items-center mb-2">
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Gender</label>
                                            <select v-model="genderselect" class="form-select">
                                                <option value="null">ALL</option>
                                                <option value="M">Male</option>
                                                <option value="F">Female</option>
                                                <option value="U">Other/Unknown</option>
                                            </select>
                                     </div>
                                </div>
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Age</label>
                                            <select v-model="ageselect" class="form-select">
                                                <option value="null">ALL</option>
                                                <option value="18-25">18-25</option>
                                                <option value="26-35">26-35</option>
                                                <option value="36-50">36-50</option>
                                                <option value="51-70">51-70</option>
                                                <option value="71-100">71+</option>
                                            </select>
                                     </div>
                                </div>
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Ethnicity</label>
                                            <select v-model="ethnicity" class="form-select" :disabled="fhacheck == 'fha'">
                                                <option value="null">ALL</option>
                                                <option value="A">Southeast Asian</option>
                                                <option value="C">Central &amp; Southwest Asian </option>
                                                <option value="E">Eastern European </option>
                                                <option value="F">All African American Ethnic Groups </option>
                                                <option value="I">Middle Eastern</option> 
                                                <option value="J">Jewish </option>
                                                <option value="M">Mediterranean</option> 
                                                <option value="N">Native American </option>
                                                <option value="O">Far Eastern </option>
                                                <option value="P">Polynesian </option>
                                                <option value="S">Scandinavian </option>
                                                <option value="T">Other </option>
                                                <option value="U">Miscellaneous Other</option> 
                                                <option value="W">Western European </option>
                                                <option value="Y">Hispanic </option>
                                                <option value="Z">Uncoded (No Group)</option>
                                            </select>
                                            <p v-if="fhacheck == 'fha'"><em>This field is disabled when activating FHA compliance mode</em></p>
                                     </div>
                                </div>
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Income</label>
                                            <select v-model="incomeselect" class="form-select">
                                                <option value="null">ALL</option>
                                                <option value="A">Under $10K</option> 
                                                <option value="B">$10K-$14K</option>
                                                <option value="C">$15K-$19K</option>
                                                <option value="D">$20K-$24K</option>
                                                <option value="E">$25K-$29K</option>
                                                <option value="F">$30K-$34K</option>
                                                <option value="G">$35K-$39K</option>
                                                <option value="H">$40K-$44K</option>
                                                <option value="I">$45K-$49K</option>
                                                <option value="J">$50K-$54K</option>
                                                <option value="K">$55K-$59K</option>
                                                <option value="L">$60K-$64K</option>
                                                <option value="M">$65K-$74K</option>
                                                <option value="N">$75K-$99K</option>
                                                <option value="O">$100K-$149K</option>
                                                <option value="P">$150K-$174K</option>
                                                <option value="Q">$175K-$199K</option>
                                                <option value="R">$200K-$249K</option>
                                                <option value="S">$250K+</option>
                                            </select>
                                     </div>
                                </div>
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Net Worth</label>
                                            <select v-model="networthselect" class="form-select">
                                                <option value="null">ALL</option>
                                                <option value="A">Less than $1</option> 
                                                <option value="B">$1-$4K</option>
                                                <option value="C">$5K-$9K</option>
                                                <option value="D">$10K-$24K</option>
                                                <option value="E">$25K-$49K</option>
                                                <option value="F">$50K-$99K</option>
                                                <option value="G">$100K-$249K</option>
                                                <option value="H">$250K-$499K</option>
                                                <option value="I">Greater than $499K</option>
                                            </select>
                                     </div>
                                </div>                                
                                <div class="col-md mb-2">
                                     <div class="form-group">
                                            <label>Credit Score</label>
                                            <select v-model="creditrating" class="form-select"  :disabled="fhacheck == 'fha'">
                                                <option value="null">ALL</option>
                                                <option value="A">800+</option> 
                                                <option value="B">750-799</option>
                                                <option value="C">700-749</option>
                                                <option value="D">650-699</option>
                                                <option value="E">600-649</option>
                                                <option value="F">550-599</option>
                                                <option value="G">500-549</option>
                                                <option value="H">under 499</option>
                                            </select>
                                            <p v-if="fhacheck == 'fha'"><em>This field is disabled when activating FHA compliance mode</em></p>
                                     </div>
                                </div>
                            </div>
                            <div class="row align-items-center mb-2">
                                <div class="col text-center"><h3>Pyschographic Variables</h3></div>
                            </div>
                            <div class="row align-items-center mb-2">
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-shopping-cart mr-4"></i> Purchases
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.purchases">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownCreditcard" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-money-check mr-4"></i> Credit Card
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownCreditcard">
                                        <div class="form-check" v-for="(data,index) in this.creditcard">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownInvesting" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-chart-line mr-4"></i> Investing
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownInvesting">
                                        <div class="form-check" v-for="(data,index) in this.investing">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownDonations" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-donate mr-4"></i> Donations
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownDonations">
                                        <div class="form-check" v-for="(data,index) in this.donations">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownHousehold" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-house mr-4"></i> Household
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownHousehold">
                                        <div class="form-check" v-for="(data,index) in this.household">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownAnimals" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-dog mr-4"></i> Animals
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownAnimals">
                                        <div class="form-check" v-for="(data,index) in this.animals">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownCareer" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-toolbox mr-4"></i> Career
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownCareer">
                                        <div class="form-check" v-for="(data,index) in this.career">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownReading" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-book mr-4"></i> Reading
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownReading">
                                        <div class="form-check" v-for="(data,index) in this.reading">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownInterests" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-biking mr-4"></i> Interests
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownInterests">
                                        <div class="form-check" v-for="(data,index) in this.interests">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownTravel" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-plane mr-4"></i> Travel
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownTravel">
                                        <div class="form-check" v-for="(data,index) in this.travel">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>
                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownLifestyle" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-laptop-house  mr-4"></i> Lifestyle
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownLifestyle">
                                        <div class="form-check" v-for="(data,index) in this.lifestyle">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownActive" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-skiing-nordic  mr-4"></i> Active
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownActive">
                                        <div class="form-check" v-for="(data,index) in this.active">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownSports" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-football-ball  mr-4"></i> Sports
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownSports">
                                        <div class="form-check" v-for="(data,index) in this.sports">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                    
                                    </div>
                                </div>

                                <div class="col-md-3 mb-2">
                                    <div class="dropdown d-grid gap-2">
                                    <button class="btn btn-lg btn-outline-primary dropdown-toggle" type="button" id="dropdownOutdoors" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fas fa-campground mr-4"></i> Outdoors
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownOutdoors">
                                        <div class="form-check" v-for="(data,index) in this.outdoors">
                                            <input class="form-check-input" type="checkbox" :value="data.value" :id="data.value" :name="data.value">
                                            <label class="form-check-label" :for="data.value">
                                                {{ data.name }}
                                            </label>
                                            </div>
                                    </ul>
                                </div>
                                

                            </div>
                            <div class="col-md-6 mb-2">
                                    <div class="d-grid gap-2">
                                        <button class="btn btn-lg btn-info">Filter Results</button>
                                        <!-- button class="btn btn-lg btn-primary" v-on:click="updateMapData()">Filter Results</button -->
                                    </div>
                                </div>
                        </div>
                        
                        </div>
                        </div>
                    </form>
                    <div class="container-fluid">
                        <div class="row"> 
                            <!-- div class="col" v-if="percentChecker()" -->
                            <div class="col">
                                <h3>{{calcPercent()}}% match all variables:</h3>
                                <p>Queried Result Total: {{this.queriedcount}}</p>
                                <p>Dataset Total Count: {{this.totalcount}}</p>
                            </div>
                        </div>
                        <div class="row" v-if="this.regiontype.length">
                            <h3>Location: {{this.locationselect}}</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-12" v-if="thequeries.length">
                                <h3>Consumer Variables:</h3>
                            </div>
                            <div class="col-md-6" v-for="(query, index) in thequeries">
                                <p class="lead"><strong>{{index+1}}.</strong> {{returnVarName(query)}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12" v-if="checkDemo">
                                <h3>Demographic Variables:</h3>
                            </div>
                            <div class="col-md-6" v-if="genderselect && genderselect !== 'null'">
                                <p class="lead"><strong>Gender:</strong> {{selectGender(this.genderselect)}}</p>
                            </div>
                            <div class="col-md-6" v-if="ageselect && ageselect !== 'null'">
                                <p class="lead"><strong>Age:</strong> {{this.ageselect}}</p>
                            </div>
                            <div class="col-md-6" v-if="incomeselect && incomeselect !== 'null'">
                                <p class="lead"><strong>Income:</strong> {{selectIncome(this.incomeselect)}}</p>
                            </div>
                            <div class="col-md-6" v-if="ethnicity && ethnicity !== 'null'">
                                <p class="lead"><strong>Ethnicity:</strong> {{selectEthnicity(this.ethnicity)}}</p>
                            </div>
                            <div class="col-md-6" v-if="networthselect && networthselect !== 'null'">
                                <p class="lead"><strong>Net Worth:</strong> {{selectNetworth(this.networthselect)}}</p>
                            </div>
                            <div class="col-md-6" v-if="creditrating && creditrating !== 'null'">
                                <p class="lead"><strong>Credit Rating:</strong> {{selectCredit(this.creditrating)}}</p>
                            </div>
                        </div>
                    </div>
        <component 
            v-bind:is="mapcomponent"
            v-bind:locationselect="locationselect"
            v-bind:locations="locations"
            v-bind:heatmaplocations="heatmaplocations"
            v-bind:maptype="maptype"
            :key="componentKey"
        />
    </div>
</template>
<script>
import axios from "axios";
import MarketResearchMap from "./MarketResearchMap.vue";
import MarketResearchHeatmapVue from './MarketResearchHeatmap.vue';
export default {
  name: "Market Research",
  components: { MarketResearchMap, MarketResearchHeatmapVue },
  data() {
    return {
      mapcomponent: MarketResearchHeatmapVue,
      locationselect: 'CA',
      componentKey: 0,
      datasets: [],
      selecteddb: '',
      maptype: 'heatmap',
      regiontype: 'state',
      fhacheck: 'all',
      checkDemo: false,
      completedataresponse: [],
      heatmaplocations: [],
      locations: [],
      thequeries: [],
      totalcount: 0,
      queriedcount: 0,
      genderselect: '',
      ageselect: '',
      incomeselect: '',
      ethnicity: '',
      networthselect: '',
      creditrating: '',
      purchases:[
        {"value": "BUY_MO_BUYER", "name": "Buy Items Via Mail"},
        {"value": "BUY_MO_RESPDR", "name": "Respond to Offers Via Mail"},
        {"value": "BUY_OL_PURCH_IND", "name": "Buy Items Online"},
        {"value": "BUY_MEM_CLUBS", "name": "Buy From Membership Clubs"},
        {"value": "BUY_VALUE_PRICED", "name": "Buy Value-Priced Items"},
        {"value": "BUY_WMNS_APPAREL", "name": "Buy Women's Apparel"},
        {"value": "BUY_WMNS_PETITE_APPAREL", "name": "Buy Petite-Sized Women's Apparel"},
        {"value": "BUY_WMNS_PLUS_APPAREL", "name": "Buy Plus-Sized Women's Apparel"},
        {"value": "BUY_YOUNG_WMNS_APPAREL", "name": "Buy Young Women's Apparel"},
        {"value": "BUY_MNS_APPAREL", "name": "Buy Men's Apparel"},
        {"value": "BUY_MNS_BIG_APPAREL", "name": "Buy Men's Big and Tall Apparel"},
        {"value": "BUY_YOUNG_MNS_APPAREL", "name": "Buy Young Men's Apparel"},
        {"value": "BUY_KIDS_APPAREL", "name": "Buy Children's Apparel"},
        {"value": "BUY_HEALTH_BEAUTY", "name": "Buy Heath and Beauty Items"},
        {"value": "BUY_COSMETICS", "name": "Buy Cosmetics"},
        {"value": "BUY_JEWELRY", "name": "Buy Jewelry"},
        {"value": "BUY_LUGGAGE", "name": "Buy Luggage"}
        ],
        creditcard: [
        {"value": "CC_AMEX_PREM", "name": "Have an American Express Premium Card"},
        {"value": "CC_AMEX_REG", "name": "Have an American express Card"},
        {"value": "CC_DISC_PREM", "name": "Have a Discover Premium Card"},
        {"value": "CC_DISC_REG", "name": "Have a Discover Card"},
        {"value": "CC_GAS_PREM", "name": "Have a Premium Gas Card"},
        {"value": "CC_GAS_REG", "name": "Have a Gas Card"},
        {"value": "CC_MC_PREM", "name": "Have a Premium Mastercard"},
        {"value": "CC_MC_REG", "name": "Have a Mastercard"},
        {"value": "CC_VISA_PREM", "name": "Have a Premium Visa Card"},
        {"value": "CC_VISA_REG", "name": "Have a Visa Card"},
        {"value": "CC_HLDR_BANK", "name": "Have a Bank Credit Card"},
        {"value": "CC_HLDR_GAS", "name": "Have a Gas Credit Card"},
        {"value": "CC_HLDR_TE", "name": "Have a Travel or Entertainment Rewards Credit Card"},
        {"value": "CC_HLDR_UNK", "name": "Have a Credit Card (Other or Unknown)"},
        {"value": "CC_HLDR_PREM", "name": "Have a Premium Credit Card"},
        {"value": "CC_HLDR_UPS_DEPT", "name": "Have an Upscale Department Store Card"},
        {"value": "CC_USER", "name": "Use a Credit Card for Purchases"},
        {"value": "CC_NEW_ISSUE", "name": "Have a Recent Credit Card"},
        {"value": "CC_BANK_CD_IN_HH", "name": "Have a Credit Card in the Household"}
        ],
        investing:[
          {"value": "INVEST_ACT", "name": "Be an Active Investor"},
          {"value": "INVEST_PERS", "name": "Manage Personal Investments"},
          {"value": "INVEST_RL_EST", "name": "Invest In Real Estate"},
          {"value": "INVEST_STOCKS", "name": "Invest in the Stock Market"},
          {"value": "INVEST_READ_FIN_NEWS", "name": "Read Financial News"},
          {"value": "INVEST_MONEY_SEEKR", "name": "Seek Money for Investing"},
          {"value": "INT_GRP_INVEST", "name": "Be Interested in Investing"},
          {"value": "INVEST_FOREIGN", "name": "Have Foreign Investments"},
          {"value": "INVEST_EST_PROP_OWN", "name": "Own Investment Properties"}
        ],
        donations:[
          {"value": "INT_GRP_DONOR", "name": "Support Charitable Causes"},
          {"value": "DONR_MAIL_ORD", "name": "Donate to a Charity by Mail"},
          {"value": "DONR_CHARITABLE", "name": "Make a Charitable Contribution"},
          {"value": "DONR_ANIMAL", "name": "Donate to Animal Welfare Causes"},
          {"value": "DONR_ARTS", "name": "Donate to the Arts"},
          {"value": "DONR_KIDS", "name": "Donate to Children's Causes"},
          {"value": "DONR_WILDLIFE", "name": "Donate to Wildelife Causes"},
          {"value": "DONR_ENVIRON", "name": "Donate to Environmental Causes"},
          {"value": "DONR_HEALTH", "name": "Donate to Health and Wellness Causes"},
          {"value": "DONR_INTL_AID", "name": "Donate to International Aid Organizations"},
          {"value": "DONR_POL", "name": "Make a Political Contribution"},
          {"value": "DONR_POL_CONS", "name": "Support Conservative Political Causes"},
          {"value": "DONR_POL_LIB", "name": "Support Liberal Political Causes"},
          {"value": "DONR_RELIG", "name": "Donate to Religious Causes"},
          {"value": "DONR_VETS", "name": "Donate to Veteran's Causes"},
          {"value": "DONR_OTH", "name": "Donate to Other Charities"},
          {"value": "DONR_COMM_CHAR", "name": "Donate to Community Causes"}
        ],
        household:[
          {"value": "VET_IN_HH", "name": "Have a Veteran in the Household"},
          {"value": "INT_OTH_PARENTING", "name": "Have an Interest in Parenting"},
          {"value": "SINGLE_PARENT", "name": "Be a Single Parent"},
          {"value": "BUY_INFANT_APPAREL", "name": "Buy Infant's Apparel"},
          {"value": "BUY_KIDS_LEARN_TOYS", "name": "Buy Educational Toys"},
          {"value": "BUY_KIDS_BABY_CARE", "name": "Buy Baby Care Items"},
          {"value": "BUY_KIDS_SCHOOL", "name": "Buy School Supplies"},
          {"value": "BUY_KIDS_GENL", "name": "Buy Children's General Merchandise"},
          {"value": "YOUNG_ADULT_IN_HH", "name": "Have a Young Adult in the Household"},
          {"value": "SR_ADULT_IN_HH", "name": "Have an Older Adult in the Household"},
          {"value": "INT_OTH_KIDS_INTS", "name": "Have Children's Interests"},
          {"value": "INT_OTH_GRANDKIDS", "name": "Have Grandchildren"},
          {"value": "INT_OTH_CHRISTIAN_FAM", "name": "Be a Christian Family"}
        ],
        animals:[
          {"value": "BUY_PETS", "name": "Buy Pet Supplies"},
          {"value": "INT_OTH_PETS_HORSE", "name": "Have a Horse"},
          {"value": "INT_OTH_PETS_CAT", "name": "Have a Cat"},
          {"value": "INT_OTH_PETS_DOG", "name": "Have a Dog"},
          {"value": "INT_OTH_PETS_OTH", "name": "Have a Pet (Other)"}
        ],
        career:[
          {"value": "INT_OTH_CAREER_IMP", "name": "View their Career as Important"},
          {"value": "OCC_WORKING_WMN", "name": "Have a Professional Woman in the Household"},
          {"value": "OCC_AFRIC_AMER_PROF", "name": "Have an African-American Professional in the Household"},
          {"value": "OCC_SOHO_IND", "name": "Use a Home Office for Work"},
          {"value": "INT_OTH_CAREER", "name": "Be Career-Focused"}
        ],
        reading:[
          {"value": "BUY_MAGAZINES", "name": "Buy Magazines"},
          {"value": "BUY_BOOKS", "name": "Buy Books"},
          {"value": "BUY_AUDIO_BOOKS", "name": "Buy Audio Books"},
          {"value": "READ_AVID", "name": "Be an Avid Reader"},
          {"value": "READ_RELIG", "name": "Read Religious and Inspirational Books"},
          {"value": "READ_SCIFI", "name": "Read Science Fiction Books"},
          {"value": "READ_MAGAZINES", "name": "Read Magazines"},
          {"value": "READ_AUDIO_BOOKS", "name": "Listen to Audio Books"},
          {"value": "INT_GRP_READ", "name": "Be Interested in Reading"},
          {"value": "READ_HIST_MLTRY", "name": "Read History and Military Books"},
          {"value": "READ_CURR_AFFAIRS", "name": "Read Books about Current Affairs"},
          {"value": "BUY_RELIGIOUS", "name": "Buy Religious Books and Items"},
          {"value": "READ_SCIENCE_SPACE", "name": "Read about Science and Space"},
          {"value": "MAGS", "name": "Buy Magazines"}
        ],
        interests:[
          {"value": "ENT_EDUC_OL", "name": "Be Interested in Online Education"},
          {"value": "ENT_GAMING", "name": "Be Interested in Video Games"},
          {"value": "OCC_COMP_GENL", "name": "Be Interested in Computers"},
          {"value": "ENT_DVD_VIDEOS", "name": "Buy DVD Videos"},
          {"value": "ENT_TV_VIDEO_MOVIE", "name": "Watch TV and Movies"},
          {"value": "OCC_HOME_OFF", "name": "Have an Office in the Home"},
          {"value": "ENT_HI_END_APPL", "name": "Have High End Appliances"},
          {"value": "ENT_STEREO", "name": "Have a Stereo"},
          {"value": "ENT_MUSIC_PLAYR", "name": "Have a Music Player"},
          {"value": "ENT_MUSIC_COLL", "name": "Collect Music"},
          {"value": "ENT_MUSIC_AVID", "name": "Be an Avid Music Fan"},
          {"value": "ENT_MOVIE_COLL", "name": "Collect Movies"},
          {"value": "ENT_CABLE_TV", "name": "Have Cable Television"},
          {"value": "ENT_VIDEO_GAMING", "name": "Play Video Games"},
          {"value": "ENT_SAT_DISH", "name": "Have a Satellite Dish"},
          {"value": "ENT_COMPUTERS", "name": "Use a Computer for Entertainment"},
          {"value": "ENT_PC_GAMING", "name": "Use a Comptuer for Gaming"},
          {"value": "ENT_CONS_ELEC", "name": "Be Interested in Consumer Electronics"},
          {"value": "INT_GRP_MOVIE_MUSIC", "name": "Be interested in Movies and Music"},
          {"value": "INT_GRP_ELEC", "name": "Be Interested in Technology"},
          {"value": "INT_OTH_TELCOMM", "name": "Be Interested in Cell Phones and Telecommunication"},
          {"value": "BUY_ANTIQUES", "name": "Buy Antiques"},
          {"value": "BUY_ART", "name": "Collect Art"},
          {"value": "ENT_THEATER", "name": "Attend the Theater"},
          {"value": "INT_OTH_THE_ARTS", "name": "Have an Interest in the Arts"},
          {"value": "ENT_MUS_INSTR", "name": "Play a Musical Instrument"},
          {"value": "INT_COLL_GENL", "name": "Be Interested in Collectables"},
          {"value": "INT_COLL_STAMPS", "name": "Collect Stamps"},
          {"value": "INT_COLL_COINS", "name": "Collect Coins"},
          {"value": "INT_COLL_ARTS", "name": "Collect Arts and Crafts"},
          {"value": "INT_COLL_ANTIQUES", "name": "Collect Antiques"},
          {"value": "INT_COLL_AVID", "name": "be an Avid Collector"},
          {"value": "INT_GRP_COLL", "name": "Have a Hobby Collection"},
          {"value": "INT_COLL_SPORTS", "name": "Collect Sports Items and Memorabilia"},
          {"value": "INT_COLL_MIL", "name": "Collect Military Items and Memorabilia"},
          {"value": "BUY_COLLECTIBLES", "name": "Buy Collectibles"},
          {"value": "INT_HOB_DIY", "name": "Have a DIY Hobby"},
          {"value": "INT_AUTO_WK", "name": "Be Interested in Auto Repair"},
          {"value": "INT_HOB_SEW", "name": "Sew Knit or Crochet"},
          {"value": "INT_HOB_WOODWK", "name": "Enjoy Woodworking"},
          {"value": "INT_HOB_PHOTO", "name": "Enjoy Photography"},
          {"value": "INT_AVIATION", "name": "Enjoy Aviation"},
          {"value": "INT_HOB_CRAFTS", "name": "Enjoy Crafts and Handiwork"},
          {"value": "INT_HOB_GARDENING", "name": "Enjoy Gardening"},
          {"value": "BUY_GARDENING", "name": "Buy Gardening Supplies"},
          {"value": "BUY_HOME_GARD", "name": "Shop for Home and Garden Items"},
          {"value": "INT_GRP_HOME_IMP", "name": "Be Interested in Gardening and Home Improvement"},
          {"value": "BUY_CRAFTS", "name": "Buy Craft Items"},
          {"value": "BUY_PHOTO_VIDEO", "name": "Buy Photo and Video Items"},
          {"value": "INT_OTH_SMOKING", "name": "Smoke Cigars Pipes or Other Tobacco"},
          {"value": "INT_OTH_HOME_DEC", "name": "Be Interested in Home Decorating"},
          {"value": "INT_HOB_HOME_IMP", "name": "Have a Home Improvement Hobby"},
          {"value": "INT_OTH_COOK_WINE", "name": "Collect Wine"},
          {"value": "INT_OTH_COOK_GNRL", "name": "Be Interested in Cooking"},
          {"value": "INT_OTH_COOK_GOURMET", "name": "Cook Gourmet Foods"},
          {"value": "INT_OTH_COOK_NAT_FOOD", "name": "Cook Organic and Natural Foods"},
          {"value": "INT_GRP_COOK", "name": "Cook at Home"},
          {"value": "INT_HOB_GAMES", "name": "Be Interested in Games"},
          {"value": "INT_TRAV_CASINO", "name": "Gamble at a Casino"},
          {"value": "INT_HOB_SWEEPS", "name": "Participate in Sweepstakes"}
        ],
        travel:[
          {"value": "INT_GRP_TRAVEL", "name": "Travel"},
          {"value": "INT_TRAV_GENL", "name": "Travel for Fun"},
          {"value": "INT_TRAV_US", "name": "Travel in the United States"},
          {"value": "INT_TRAV_INTL", "name": "Travel Internationally"},
          {"value": "INT_TRAV_CRUISE", "name": "Take a Pleasure Cruise"}
        ],
        lifestyle:[
          {"value": "LIFE_HOME", "name": "Have a Home/Garde Lifestyle"},
          {"value": "LIFE_DIY", "name": "Have a DIY Lifestyle"},
          {"value": "LIFE_SPORTY", "name": "Have a Sports Lifestyle"},
          {"value": "LIFE_UPSCALE", "name": "Have an Upscale Lifestyle"},
          {"value": "LIFE_CULTURE", "name": "Have a Culture/Arts Lifestyle"},
          {"value": "LIFE_HIGHBROW", "name": "Have a Highbrow Lifestyle"},
          {"value": "LIFE_HT", "name": "Have a High Tech Lifestyle"},
          {"value": "LIFE_PROF", "name": "Have a Professional Lifestyle"}
        ],
        active:[
          {"value": "INT_GRP_EXER", "name": "Be Interested In Exercise"},
          {"value": "INT_FIT_JOG", "name": "Jog for Exercise"},
          {"value": "INT_FIT_WALK", "name": "Walk For Exercise"},
          {"value": "INT_FIT_AEROB", "name": "Do Aerobics"}
        ],
        sports:[
          {"value": "INT_SPORT_SPECT_AUTO", "name": "Watch Auto Racing"},
          {"value": "INT_SPORT_SPECT_TV_SPORTS", "name": "Watch Television Sports"},
          {"value": "INT_SPORT_SPECT_FOOT", "name": "Watch Football"},
          {"value": "INT_SPORT_SPECT_BASE", "name": "Watch Baseball"},
          {"value": "INT_SPORT_SPECT_BSKT", "name": "Watch Basketball"},
          {"value": "INT_SPORT_SPECT_HOCKEY", "name": "Watch Hockey"},
          {"value": "INT_SPORT_SPECT_SOCCER", "name": "Watch Soccer"},
          {"value": "INT_SPORT_TENNIS", "name": "Play Tennis"},
          {"value": "INT_SPORT_GOLF", "name": "Play Golf"},
          {"value": "INT_SPORT_SNOW_SKI", "name": "Ski"},
          {"value": "INT_SPORT_MTRCYCL", "name": "Be Interested in Motorcycles"},
          {"value": "INT_SPORT_NASCAR", "name": "Watch Nascar"},
          {"value": "INT_SPORT_BOATING", "name": "Be Interested in Boating"},
          {"value": "INT_SPORT_SCUBA", "name": "Be Interested in SCUBA Diving"},
          {"value": "BUY_SPORT_LEIS", "name": "Have a Sports or Leisure Interest"}
        ],
        outdoors:[
          {"value": "BUY_HUNTING", "name": "Hunt for Sport"},
          {"value": "INT_SPORT_FISHING", "name": "Fish for Sport"},
          {"value": "INT_SPORT_CAMP", "name": "Enjoy Camping and Outdoors"},
          {"value": "INT_SPORT_SHOOT", "name": "Be Interested in Shooting and Firearms"},
          {"value": "INT_GRP_SPORTS", "name": "Have a Sports Hobby"},
          {"value": "INT_GRP_OUTDOOR", "name": "Have an Outdoor Interest"}
        ]
    }
  },
methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    selectMapType(value) {
        // console.log('passed value '+value);
        this.maptype = value;
        if(value === 'markers') {
            this.mapcomponent = MarketResearchMap;
        } else if(value === 'heatmap') {
            this.mapcomponent = MarketResearchHeatmapVue;
        }
    },
    calcPercent() {
        if(this.queriedcount !== 0) {
            var finalpercent = this.queriedcount / this.totalcount * 100;
            return finalpercent.toFixed(2);
        } else {
            return 0;
        } 
    },
    percentChecker() {
        if(this.queriedcount >= 1) {
            return true;
        } else {
            return false;
        }
    },
    returnVarName(val) {
        var alloptions = [];
        alloptions.push(this.purchases);
        alloptions.push(this.creditcard);
        alloptions.push(this.investing);
        alloptions.push(this.donations);
        alloptions.push(this.household);
        alloptions.push(this.animals);
        alloptions.push(this.career);
        alloptions.push(this.reading);
        alloptions.push(this.interests);
        alloptions.push(this.travel);
        alloptions.push(this.lifestyle);
        alloptions.push(this.active);
        alloptions.push(this.sports);
        alloptions.push(this.outdoors);
        alloptions = alloptions.flat();
        let obj = alloptions.find(o => o.value === val);
        return obj['name'];
    },
    trimBlankRecords(data) {
        var iH = [];
        var b = data;
            for(var j = 0; j < b.length; j++){
                if ("lat" in b[j]) {
                    iH.push(b[j]); 
                }                        
            }
        return iH;
    },
    queryLocations(thedata) {
        var endresult = [];
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = false;
                if(this.regiontype === 'zipcode') {
                    var thezipcode = this.locationselect;
                    if(thedata[j]['ZIP'] === thezipcode) {
                        currentrecord = true;
                    }
                    
                };
                if(this.regiontype === 'state') {
                    var thestate = this.locationselect;
                    if(thedata[j]['ST'] === thestate) {
                        currentrecord = true;
                    }
                }
            if(currentrecord === true) {
                endresult.push(thedata[j]);
            }
        };
        return endresult;
    },
    querySelection(thedata,thequery) {
        var endresult = [];
        //this.queriedcount = 0;
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = false;
            for (var i = 0; i < thequery.length; i++) {
                if(thedata[j][thequery[i]] === 'Y') {
                    currentrecord = true;
                } else {
                    currentrecord = false;
                }    
            }
            if(currentrecord === true) {
                endresult.push(thedata[j]);
                //this.queriedcount++;
            }
        };
        return endresult;
    },
    queryDemographics(thedata) {
        //var testQuery = [];
        var endresult = [];
        var agevar = this.ageselect.split("-");
        this.queriedcount = 0;
        this.checkDemo = false;
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = true;
            if(this.genderselect && this.genderselect !== "null" && thedata[j]['GENDER'] !== this.genderselect) {
                currentrecord = false;
                //testQuery.push({'GENDER':this.genderselect});
            };
            if(this.ageselect && this.ageselect !== "null"  && (thedata[j]['AGE'] >= agevar[0] && thedata[j]['AGE'] <= agevar[1])) {
                currentrecord = false;
                //testQuery.push({'AGE':this.ageselect});
            };
            if(this.incomeselect && this.incomeselect !== "null"  && thedata[j]['HH_INCOME'] !== this.incomeselect) {
                currentrecord = false;
                //testQuery.push({'HH_INCOME':this.incomeselect});
            };
            if(this.ethnicity && this.ethnicity !== "null"  && thedata[j]['ETHNIC_GRP'] !== this.ethnicity) {
                currentrecord = false;
                //testQuery.push({'ETHNIC_GRP':this.ethnicity});
            };
            if(this.networthselect && this.networthselect !== "null"  && thedata[j]['NET_WORTH'] !== this.networthselect) {
                currentrecord = false;
                //testQuery.push({'NET_WORTH':this.networthselect});
            };
            if(this.creditrating && this.creditrating !== "null"  && thedata[j]['CREDIT_RATING'] !== this.creditrating) {
                currentrecord = false;
                //testQuery.push({'CREDIT_RATING':this.creditrating});
            };
            if(currentrecord === true) {
                endresult.push(thedata[j]);
                this.queriedcount++;
                this.checkDemo = true;
            }
        };
        // console.log('end result demo query format: '+JSON.stringify(testQuery));
        return endresult;
    },
    selectGender(val) {
        if(val == 'M') {
            return 'Male'
        } else if(val == 'F') {
            return 'Female'
        } else if(val == 'U') {
            return 'Other/Unknown'
        }
    },
    selectEthnicity(val) {
        if(val == 'A') {
            return "Southeast Asian";
        } else if(val == 'C') {
            return "Central &amp; Southwest Asian";
        } else if(val == 'E') {
            return "Eastern European";
        } else if(val == 'F') {
            return "All African American Ethnic Groups";
        } else if(val == 'I') {
            return "Middle Eastern";
        } else if(val == 'J') {
            return "Jewish";
        } else if(val == 'M') {
            return "Mediterranean";
        } else if(val == 'N') {
            return "Native American";
        } else if(val == 'O') {
            return "Far Eastern";
        } else if(val == 'P') {
            return "Polynesian";
        } else if(val == 'S') {
            return "Scandinavian";
        } else if(val == 'T') {
            return "Other";
        } else if(val == 'U') {
            return "Miscellaneous Other";
        } else if(val == 'W') {
            return "Western European";
        } else if(val == 'Y') {
            return "Hispanic";
        } else if(val == 'Z') {
            return "Uncoded (No Group)";
        }
    },
    selectIncome(val) {
        if(val == 'A') {
            return "Under $10K";
        } else if(val == 'B') {
            return "$10K-$14K";
        } else if(val == 'C') {
            return "$15K-$19K";
        } else if(val == 'D') {
            return "$20K-$24K";
        } else if(val == 'E') {
            return "$25K-$29K";
        } else if(val == 'F') {
            return "$30K-$34K";
        } else if(val == 'G') {
            return "$35K-$39K";
        } else if(val == 'H') {
            return "$40K-$44K";
        } else if(val == 'I') {
            return "$45K-$49K";
        } else if(val == 'J') {
            return "$50K-$54K";
        } else if(val == 'K') {
            return "$55K-$59K";
        } else if(val == 'L') {
            return "$60K-$64K";
        } else if(val == 'M') {
            return "$65K-$74K";
        } else if(val == 'N') {
            return "$75K-$99K";
        } else if(val == 'O') {
            return "$100K-$149K";
        } else if(val == 'P') {
            return "$150K-$174K";
        } else if(val == 'Q') {
            return "$175K-$199K";
        } else if(val == 'R') {
            return "$200K-$249K";
        } else if(val == 'S') {
            return "$250K+";
        }
    },
    selectNetworth(val) {
        if(val == 'A') {
            return 'Less than $1';
        } else if(val == 'B') {
            return '$1-$4K';
        } else if(val == 'C') {
            return '$5K-$9K';
        } else if(val == 'D') {
            return "$10K-$24K";
        } else if(val == 'E') {
            return "$25K-$49K";
        } else if(val == 'F') {
            return "$50K-$99K";
        } else if(val == 'G') {
            return "$100K-$249K";
        } else if(val == 'H') {
            return "$250K-$499K";
        } else if(val == 'I') {
            return "Greater than $499K";
        }
    },
    selectCredit(val) {
        if(val == 'A') {
            return "800+";
        } else if(val == 'B') {
            return "750-799";
        } else if(val == 'C') {
            return "700-749";
        } else if(val == 'D') {
            return "650-699";
        } else if(val == 'E') {
            return "600-649";
        } else if(val == 'F') {
            return "550-599";
        } else if(val == 'G') {
            return "500-549";
        } else if(val == 'H') {
            return "under 499";
        }
    },
    csvJSON(csv) {
            var lines=csv.replace('\r', '').split("\n");
            var result = [];
            var headers=lines[0].split(",");
            for(var i=1;i<lines.length;i++){
                var obj = {};
                var currentline=lines[i].split(",");
                for(var j=0;j<headers.length;j++){
                    var curline = currentline[j];
                    var necurline = (curline ?? '"').replaceAll('"', '');
                    obj[headers[j]] = necurline;
                }
                result.push(obj);
            }
            return result;
        },
    buildLocations(incoming) {
        for(var j = 0; j < incoming.length; j++){
            for (var key in incoming[j]) {
                if(key === 'LATITUDE') {
                    if(incoming[j]['LATITUDE']) {
                        incoming[j]['lat'] = parseFloat(incoming[j]['LATITUDE']); 
                    }
                    delete incoming[j]['LATITUDE'];
                } else if(key === 'LONGITUDE') {
                    if(incoming[j]['LONGITUDE']) {
                        incoming[j]['lng'] = parseFloat(incoming[j]['LONGITUDE']); 
                    }
                    delete incoming[j]['LONGITUDE'];
                } else {
                    delete incoming[j][key]
                }
            };
        };
        return incoming;
    },
    buildHeatmap(incoming) {
        var outgoing = [];
        for(var j = 0; j < incoming.length; j++){
            outgoing.push({ location: incoming[j], weight: 3});
        };
        return outgoing;
    },
    updateMapData() {
        // console.log('test age selection '+this.ageselect);
        // console.log('test ethnicity selection '+this.ethnicity);
        // console.log('test income selection '+this.incomeselect);
        let myForm = document.getElementById('mapsearch'); 
        let formData = new FormData(myForm);
        var finalDb = '';
        if(this.selecteddb) {
            finalDb = 'appended-'+this.selecteddb+'.csv';
            formData.append('dataset', finalDb);
        }
        this.thequeries = [];
        for (var pair of formData.entries()) {
            if(pair[0] != "dataset") {
                this.thequeries.push(pair[0]);
            }
        }
            axios({
                method : 'POST',
                url : '/update_market_research',
                data: formData
            }).then(
                (response) => {
                    this.completedataresponse = this.csvJSON(response.data);
                    this.totalcount = this.completedataresponse.length;
                    var prequery = [];
                    var finalquery = [];
                    if(this.regiontype.length) {
                        var filteredlocations = this.queryLocations(this.completedataresponse);
                    } else {
                        var filteredlocations = this.completedataresponse;
                    }
                    if(this.thequeries.length) {
                        prequery = this.querySelection(filteredlocations,this.thequeries);
                    } else {
                        prequery = filteredlocations;
                    };
                    if(prequery.length) {
                        finalquery = this.queryDemographics(prequery);
                    } else {
                        finalquery = prequery;
                    };
                    this.queriedcount = finalquery.length;
                    var fixedloc = this.buildLocations(finalquery);
                    this.locations = this.trimBlankRecords(fixedloc);
                    this.heatmaplocations = this.buildHeatmap(this.locations);
                    this.forceRerender();  
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
    }
  },
  mounted() {
    axios({
            method : 'POST',
            url : '/list_datasets',
            data:'',
        }).then(response => this.datasets = processDatasetList(response.data))
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
        });
    //if(!this.selecteddb) {
        this.updateMapData();
    //}
  }
};
function processDatasetList(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
}
</script>